export const PackingListTab = 'PackingListTab'
export const PickUpInfoTab = 'PickUpInfoTab'
export const OrderJobsTab = 'OrderJobTab'
export const NotesTab = 'NotesTab'
export const JobContentTab = 'JobContentTab'
export const PalletListTab = 'PalletListTab'
export const NotAvaliablePaletsTab = 'NotAvaliablePaletsTab'
export const LocalPalletsGroupTab = 'LocalPalletsGroupTab'
export const GoodsListTab = 'GoodsListTab'
export const ShipmentJobsTab = 'ShipmentJobsTab'
export const ShipmentPalletsTab = 'ShipmentPalletsTab'
export const JobListTab = 'JobListTab'
export const InboundJobsTab = 'InboundJobsTab'
export const ThisWeekTab = 'This Week'
export const ThisMonthTab = 'This Month'
export const TodayTab = 'Today Tab'
export const ShipmentShiped = 'Shipped'
export const CustomerOrdersTab = 'CustomerOrdersTab'

export const Tabs = {
  PackingListTab,
  JobListTab,
  LocalPalletsGroupTab,
  PickUpInfoTab,
  OrderJobsTab,
  NotesTab,
  JobContentTab,
  PalletListTab,
  NotAvaliablePaletsTab,
  GoodsListTab,
  ShipmentJobsTab,
  ShipmentPalletsTab,
  InboundJobsTab,
  ThisWeekTab,
  ThisMonthTab,
  TodayTab,
  ShipmentShiped
}

export const UnloadingOrderTabs = [
  PackingListTab,
  PalletListTab,
  JobListTab,
  NotesTab
]

export const LocalOrderTabs = [
  LocalPalletsGroupTab,
  PalletListTab,
  JobListTab,
  NotesTab
]

export const ScanOrderTabs = [
  CustomerOrdersTab,
  JobListTab,
  NotesTab
]

export const ShipmentPickUpTabs = [
  TodayTab,
  ThisWeekTab,
  ThisMonthTab,
  ShipmentShiped
]

export const TabsMixin = {
  data: function () {
    return {
      JobListTab,
      PackingListTab,
      LocalPalletsGroupTab,
      PickUpInfoTab,
      OrderJobsTab,
      NotesTab,
      JobContentTab,
      PalletListTab,
      NotAvaliablePaletsTab,
      ShipmentJobsTab,
      ShipmentPalletsTab,
      InboundJobsTab,
      GoodsListTab,
      CustomerOrdersTab
    }
  }
}
